import React, { useState } from "react";
import closeIcon from "../../../../../../../../Assets/images/close-icon.svg";
import phoneIcon from "../../../../../../../../Assets/images/phonenumber-icon.svg";
import mailIcon from "../../../../../../../../Assets/images/mailid-icon.svg";
import moment from "moment";
import "./TruckDetails.scss";
import { DATE_FORMAT } from "../../../../../../../CC/src/Utils/Constants";

const TruckDetails = ({ truck, onClose }) => {
  const [activeTab, setActiveTab] = useState("truckinfo");

  const getInitials = (firstName = "", lastName = "") => {
    const f = firstName.charAt(0).toUpperCase();
    const l = lastName.charAt(0).toUpperCase();
    return `${f}${l}`;
  };


  if (!truck) return null;

  return (
    <div className="modal-backdrop-custom">
      <div className="modal-1 right rtm-modal show d-block" tabIndex="-1" role="dialog">
        <div className="modal-dialog rtl-dialog">
          <div className="modal-content rtl-content animate__animated animate__fadeInRight" style={{ maxHeight: "100vh", overflow: "hidden" }}>
            <div className="ajob-content" style={{ maxHeight: "70px", overflowY: "auto" }}>
              <div className="cpf-top-no-title">
                <button className="m-close" onClick={onClose} style={{ border: "none", background: "transparent" }}>
                  <img src={closeIcon} alt="Close" />
                </button>
              </div>

              <div className="modal-inner">
                <div className="modal-graybox">
                  <div className="modal-profile">
                    <h1 className="common-profile-letter">
                      {getInitials(
                        truck?.companyInfo?.company_name?.split(" ")[0] || "",
                        truck?.companyInfo?.company_name?.split(" ")[1] || ""
                      )}
                    </h1>
                  </div>
                  <div className="modal-grayleft">
                    <h2 className="graybox-title">{truck?.companyInfo?.company_name || "--"}</h2>
                    <p className="graybox-text">{truck?.companyInfo?.address1 || "--"}</p>
                  </div>
                  <div className="graybox-right">
                    <div className="graybox-split">
                      <img src={phoneIcon} alt="Phone" />
                      <p className="contact-text">{truck?.companyInfo?.contact_no || "--"}</p>
                    </div>
                    <div className="graybox-split">
                      <img src={mailIcon} alt="Email" />
                      <p className="contact-text">{truck?.companyInfo?.email_id || "--"}</p>
                    </div>
                  </div>
                </div>

                <div className="modal-tabs mt-3">
                  <ul className="nav nav-tabs tab-line">
                    <li className="nav-item">
                      <button
                        className={`nav-link tab-btn ${activeTab === "truckinfo" ? "active" : ""}`}
                        onClick={() => setActiveTab("truckinfo")}
                      >
                        Truck Info
                      </button>
                    </li>
                    <li className="nav-item">
                      <button
                        className={`nav-link tab-btn ${activeTab === "driverinfo" ? "active" : ""}`}
                        onClick={() => setActiveTab("driverinfo")}
                      >
                        Driver Info
                      </button>
                    </li>
                  </ul>

                  <div className="modal-tabcontent mt-3">
                    {activeTab === "truckinfo" && (
                      <div className="truckinfo-inner">
                        <div className="tri-wraper">
                          <div className="row">
                            <div className="col-md-6">
                              <div className="modal-left-split">
                                <h3 className="modal-subhead">Vehicle Number</h3>
                                <p className="modal-value">{truck.vehicle_no || "--"}</p>
                              </div>
                            </div>
                            <div className="col-md-6">
                              <div className="modal-left-split">
                                <h3 className="modal-subhead">Permit (MTO Permit)</h3>
                                <p className="modal-value">{truck.permit_no || "--"}</p>
                              </div>
                            </div>
                          </div>

                          <div className="row">
                            <div className="col-md-6">
                              <div className="modal-left-split">
                                <h3 className="modal-subhead">License Plate Number</h3>
                                <p className="modal-value">{truck.license_plate_no || "--"}</p>
                              </div>
                            </div>
                            <div className="col-md-6">
                              <div className="modal-left-split">
                                <h3 className="modal-subhead">Ownership</h3>
                                <p className="modal-value">{truck?.companyInfo?.company_name || "--"}</p>
                              </div>
                            </div>
                          </div>

                          <div className="row">
                            <div className="col-md-6">
                              <div className="modal-left-split">
                                <h3 className="modal-subhead">Truck Type</h3>
                                <p className="modal-value">{truck.truck_type || "--"}</p>
                              </div>
                            </div>
                            <div className="col-md-6">
                              <div className="modal-left-split">
                                <h3 className="modal-subhead">Insurance Number</h3>
                                <p className="modal-value">{truck.insurance_no || "--"}</p>
                              </div>
                            </div>
                          </div>

                          <div className="row">
                            <div className="col-md-6">
                              <div className="modal-left-split">
                                <h3 className="modal-subhead">Last Updated On</h3>
                                <p className="modal-value">
                                  {truck.last_upated_datetime
                                    ? moment(truck.last_upated_datetime).format(DATE_FORMAT)
                                    : "--"}
                                </p>
                              </div>
                            </div>
                          </div>
                        </div>
                      </div>
                    )}

                    {activeTab === "driverinfo" && (
                      <div className="tri-wraper">
                        <div className="modal-graybox sub-graybox">
                          <div className="modal-profile">
                            <h1 className="common-profile-letter">
                              {getInitials(
                                truck?.driverDetails?.first_name || "",
                                truck?.driverDetails?.last_name || ""
                              )}
                            </h1>
                          </div>
                          <div className="modal-grayleft sub-grayleft">
                            <h2 className="graybox-title">{truck.driver || "Driver Name Not Provided"}</h2>
                          </div>
                          <div className="graybox-right">
                            <div className="graybox-split">
                              <img src={phoneIcon} alt="Phone" />
                              <p className="contact-text">{truck?.driverDetails?.contact_no || "--"}</p>
                            </div>
                            <div className="graybox-split">
                              <img src={mailIcon} alt="Email" />
                              <p className="contact-text">{truck?.driverDetails?.email_id || "--"}</p>
                            </div>
                          </div>
                        </div>

                        <div className="tri-wraper mt-3">
                          <div className="row">
                            <div className="col-md-6">
                              <div className="modal-left-split">
                                <h3 className="modal-subhead">Driver License No.</h3>
                                <p className="modal-value"> {truck?.license_plate_no || "--"}</p>
                              </div>
                            </div>
                            <div className="col-md-6">
                              <div className="modal-left-split">
                                <h3 className="modal-subhead">Last Updated On</h3>
                                <p className="modal-value">{truck?.last_upated_datetime?moment.utc(truck.last_upated_datetime).local().format(DATE_FORMAT): "--"}</p>
                              </div>
                            </div>
                          </div>
                        </div>
                      </div>
                    )}
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default TruckDetails;
